var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { Suspense } from 'react';
import { ViewerScriptWrapper } from '@wix/native-components-infra';
import { listenToHeightChanges } from 'wix-height-updater';
import { factory as biLoggerFactory } from '@wix/fe-essentials-viewer-platform/bi';
import { ErrorBoundary } from './react/ErrorBoundary';
import { WixSDK } from './react/SDK/SDKRenderProp';
import { getWidgetWrapper } from './WidgetWrapper';
import { createControllers, initAppForPageWrapper } from './viewerScript.js';
import { WixSDKProvider } from './react/SDK/WixSDKProvider';
import { createExperimentsFromEssentials } from './experiments';
// TODO: fill overrides and whatnot from SantaWrapper
export var createEditorAppForWixSDK = function (_a) {
    var UserComponent = _a.UserComponent, userController = _a.userController, customInitAppForPage = _a.customInitAppForPage, name = _a.name, localeDistPath = _a.localeDistPath, sentryConfig = _a.sentryConfig, experimentsConfig = _a.experimentsConfig, translationsConfig = _a.translationsConfig, defaultTranslations = _a.defaultTranslations, fedopsConfig = _a.fedopsConfig, projectName = _a.projectName, biConfig = _a.biConfig, biLogger = _a.biLogger, sdk = _a.sdk, stylesParams = _a.stylesParams, _b = _a.wrapperOptions, wrapperOptions = _b === void 0 ? {} : _b, _c = _a.withErrorBoundary, withErrorBoundary = _c === void 0 ? false : _c, appDefinitionId = _a.appDefinitionId, componentId = _a.componentId, optionalDeps = _a.optionalDeps, prepopulatedData = _a.prepopulatedData, shouldUseEssentials = _a.shouldUseEssentials, shouldSkipMultipleRendersAfterViewModeChange = _a.shouldSkipMultipleRendersAfterViewModeChange;
    var WithComponent = getWidgetWrapper(optionalDeps, UserComponent, {
        name: name,
        componentId: componentId,
        Wix: sdk.Wix,
        translationsConfig: translationsConfig,
        sentryConfig: null,
        withErrorBoundary: withErrorBoundary,
        stylesParams: stylesParams,
        localeDistPath: localeDistPath,
    });
    var createEssentialsExperiments = optionalDeps.createExperiments
        ? function (_a) {
            var _b;
            var scopes = _a.scopes, requestContext = _a.requestContext;
            return optionalDeps.createExperiments({
                ctx: (_b = requestContext.forSiteVisitors) !== null && _b !== void 0 ? _b : requestContext.forSiteOwner,
                experimentsConfig: {
                    scopes: scopes !== null && scopes !== void 0 ? scopes : [],
                },
            });
        }
        : null;
    return ViewerScriptWrapper(WithComponent, __assign({ viewerScript: {
            createControllers: createControllers(optionalDeps, userController, translationsConfig, experimentsConfig, defaultTranslations, fedopsConfig, sentryConfig, biConfig, biLogger, projectName, appDefinitionId, componentId, localeDistPath, prepopulatedData, shouldUseEssentials, withErrorBoundary),
            initAppForPage: initAppForPageWrapper({
                initAppForPage: customInitAppForPage,
                defaultTranslations: defaultTranslations,
                translationsConfig: translationsConfig,
                sentryConfig: sentryConfig,
                experimentsConfig: experimentsConfig,
                inEditor: true,
                projectName: projectName,
                biLogger: biLogger,
                biConfig: biConfig,
                appName: null,
                optionalDeps: optionalDeps,
                localeDistPath: localeDistPath,
                prepopulatedData: prepopulatedData,
                shouldUseEssentials: shouldUseEssentials,
            }),
        }, Wix: sdk.Wix, shouldSkipMultipleRendersAfterViewModeChange: shouldSkipMultipleRendersAfterViewModeChange, widgetConfig: {
            widgetId: componentId,
            getAllPublicData: true,
        }, overrides: {
            createCentralizedExperiments: createEssentialsExperiments && (experimentsConfig === null || experimentsConfig === void 0 ? void 0 : experimentsConfig.centralized)
                ? function (_a) {
                    var ctx = _a.ctx;
                    return __awaiter(void 0, void 0, void 0, function () {
                        var experimentsPromise, experiments;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    experimentsPromise = createExperimentsFromEssentials(createEssentialsExperiments, __assign(__assign({}, experimentsConfig), { scopes: __spreadArrays(experimentsConfig.scopes, [
                                            "viewer-apps-" + appDefinitionId,
                                        ]) }), undefined, ctx, sdk.Wix
                                        ? {
                                            entityId: sdk.Wix.Utils.getInstanceValue('metaSiteId'),
                                        }
                                        : undefined);
                                    return [4 /*yield*/, experimentsPromise];
                                case 1:
                                    experiments = _b.sent();
                                    return [2 /*return*/, experiments];
                            }
                        });
                    });
                }
                : undefined,
            fedopsLogger: optionalDeps.fedopsLogger,
            essentials: {
                biLoggerFactory: biLoggerFactory,
                createExperiments: createEssentialsExperiments,
                httpClient: null,
                createErrorMonitor: optionalDeps.createErrorMonitor,
            },
            controllerEssentials: {
                biLoggerFactory: biLoggerFactory,
                createExperiments: createEssentialsExperiments,
                fedopsLogger: optionalDeps.fedopsLogger
                    ? optionalDeps.fedopsLogger.create(appDefinitionId + "_" + componentId + "_iframe")
                    : null,
                createErrorMonitor: optionalDeps.createErrorMonitor,
            },
            platform: {
                shouldMergeBaseUrls: true,
                baseUrls: {
                    staticsBaseUrl: window.__STATICS_BASE_URL__,
                },
            },
        } }, wrapperOptions));
};
var EditorAppWithCreator = /** @class */ (function (_super) {
    __extends(EditorAppWithCreator, _super);
    function EditorAppWithCreator(props) {
        var _this = _super.call(this, props) || this;
        var EditorAppComponent = null;
        if (props.sdk.Wix) {
            EditorAppComponent = createEditorAppForWixSDK(props);
            // Just to verify we are not exposing it.
        }
        else if (props.sdk.editorSDK) {
            throw new Error('Editor App does not support editorSDK');
        }
        _this.state = {
            EditorAppComponent: EditorAppComponent,
        };
        return _this;
    }
    EditorAppWithCreator.prototype.render = function () {
        var EditorAppComponent = this.state.EditorAppComponent;
        if (!EditorAppComponent) {
            return null;
        }
        return React.createElement(EditorAppComponent, __assign({}, this.props));
    };
    return EditorAppWithCreator;
}(React.Component));
export default (function (props) {
    return (React.createElement(Suspense, { fallback: React.createElement("div", null, "Loading...") },
        React.createElement(WixSDKProvider, null,
            React.createElement(WixSDK, null, function (sdk) {
                listenToHeightChanges(window.Wix, window);
                if (process.env.NODE_ENV === 'development' &&
                    !props.withErrorBoundary) {
                    return React.createElement(EditorAppWithCreator, __assign({ sdk: sdk }, props));
                }
                if (!props.sentryConfig) {
                    return (React.createElement(ErrorBoundary, { handleException: function (error) { return console.log(error); } },
                        React.createElement(EditorAppWithCreator, __assign({ sdk: sdk }, props))));
                }
                var Wix = sdk
                    ? sdk.Wix
                    : null;
                if (Wix) {
                    window.Sentry.configureScope(function (scope) {
                        scope.setTag('msid', Wix.Utils.getInstanceValue('metaSiteId'));
                        scope.setTag('environment', 'Editor');
                        scope.setTag('componentId', props.componentId);
                        scope.setTag('componentName', props.name);
                        scope.setUser({
                            id: Wix.Utils.getInstanceValue('uid'),
                        });
                    });
                }
                return (React.createElement(ErrorBoundary, { handleException: window.Sentry.captureException },
                    React.createElement(EditorAppWithCreator, __assign({ sdk: sdk }, props))));
            }))));
});
//# sourceMappingURL=EditorAppWrapper.js.map